import {useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import moment from "moment";
import CustomChipComponent from "../../../../core/components/common/custom-chip.component";

const ListVehicleAccessLogComponent = (props) => {
    const {headers, data} = props;

    const theme = useTheme();


    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((log) => (
                                <TableRow key={log.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                        {log?.plate_number}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        <CustomChipComponent category="vehicleEntryTypeStatus"
                                            label={(log?.entry_type === "IN") ? "Gate In" 
                                                :
                                                    (log?.entry_type === "OUT") ? "Gate Out"                           
                                                :
                                                    log?.entry_type
                                            }
                                        />
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {log?.purpose}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {moment(log?.timestamp).format("MM/DD/YYYY HH:mm A")}
                                    </TableCell>                                   
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No access logs available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default ListVehicleAccessLogComponent